import NavbarComponent from "./components/NavbarComponent";
import LoginComponent from "./components/LoginComponent";
import FooterComponent from "./components/FooterComponent";
import axios from "axios";
import React, { useState, ChangeEvent, FormEvent } from "react";
import Swal from "sweetalert2";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import './App.css';

interface AppState {
    longUrl: string;
    shortUrl: string;
}

function App() {
    const [state, setState] = useState<AppState>({
        longUrl: "",
        shortUrl: "",
    });
    const { longUrl, shortUrl } = state;

    const inputValue = (name: keyof AppState) => (event: ChangeEvent<HTMLInputElement>) => {
        setState({ ...state, [name]: event.target.value });
    };

    const sendPostForm = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        axios.post(`${process.env.REACT_APP_API}guest/shortlink`, { link: longUrl },
            {
                headers: {
                    Authorization: `Bearer `
                }
            })
        .then(response => {
            console.log(response);
            setState({ ...state, longUrl: longUrl, shortUrl: response.data.result.short_url });
        }).catch(() => {
            Swal.fire(
                "Error",
                "ERROR",
                "error",
            );
        });
    };

    return (
        <div className="d-flex h-100 bg-dark">
            <div className="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column text-center text-white min-h-max">
                <NavbarComponent />
                <div className="container p-5">
                    <main className="px-3">
                        <form onSubmit={sendPostForm}>
                            <div className="row">
                                <label htmlFor="long_url" className="col-3 col-form-label">Your Url : </label>
                                <div className="col-6">
                                    <input type="text" className="form-control" name="long_url" id="long_url" value={longUrl} onChange={inputValue("longUrl")} />
                                </div>
                                <div className="col-3">
                                    <input type="submit" className="btn btn-info" id="genshortlink" value="Generate" />
                                </div>
                            </div>
                            <div className="row mt-5">
                                <label htmlFor="long_url" className="col-3 col-form-label">Short URL : </label>
                                <label id="short_url" className="col-9 col-form-label text-start">
                                    <a target="_blank" rel="noreferrer" href={shortUrl}>{shortUrl}</a>
                                </label>
                            </div>
                        </form>
                    </main>
                </div>
                <FooterComponent />
            </div>
            <LoginComponent />
        </div>
    );
}

export default App;
